export default __webpack_public_path__ + "static/media/cerner-logo.418037e1.svg";